import React from "react";

const DownloadIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V13.1893L16.4697 9.46967C16.7626 9.17678 17.2374 9.17678 17.5303 9.46967C17.8232 9.76256 17.8232 10.2374 17.5303 10.5303L12.5303 15.5303C12.2374 15.8232 11.7626 15.8232 11.4697 15.5303L6.46967 10.5303C6.17678 10.2374 6.17678 9.76256 6.46967 9.46967C6.76256 9.17678 7.23744 9.17678 7.53033 9.46967L11.25 13.1893V3C11.25 2.58579 11.5858 2.25 12 2.25ZM3 14.25C3.41421 14.25 3.75 14.5858 3.75 15V16.2C3.75 17.0525 3.75058 17.6467 3.78838 18.1093C3.82547 18.5632 3.8946 18.824 3.99524 19.0215C4.21095 19.4448 4.55516 19.789 4.97852 20.0048C5.17604 20.1054 5.4368 20.1745 5.89068 20.2116C6.35331 20.2494 6.94755 20.25 7.8 20.25H16.2C17.0525 20.25 17.6467 20.2494 18.1093 20.2116C18.5632 20.1745 18.824 20.1054 19.0215 20.0048C19.4448 19.789 19.789 19.4448 20.0048 19.0215C20.1054 18.824 20.1745 18.5632 20.2116 18.1093C20.2494 17.6467 20.25 17.0525 20.25 16.2V15C20.25 14.5858 20.5858 14.25 21 14.25C21.4142 14.25 21.75 14.5858 21.75 15V16.2321C21.75 17.045 21.75 17.7006 21.7066 18.2315C21.662 18.7781 21.5676 19.2582 21.3413 19.7025C20.9817 20.4081 20.4081 20.9817 19.7025 21.3413C19.2582 21.5676 18.7781 21.662 18.2315 21.7066C17.7006 21.75 17.045 21.75 16.2321 21.75H7.76788C6.95505 21.75 6.29944 21.75 5.76853 21.7066C5.2219 21.662 4.74175 21.5676 4.29754 21.3413C3.59193 20.9817 3.01825 20.4081 2.65873 19.7025C2.43239 19.2582 2.33803 18.7781 2.29336 18.2315C2.24999 17.7006 2.24999 17.0449 2.25 16.2321L2.25 15C2.25 14.5858 2.58579 14.25 3 14.25Z"
        fill="#17142A"
      />
    </svg>
  );
};

export default DownloadIcon;
